import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../utils/formatDate";
import { toast } from "react-toastify";
import axiosAdmin from "../../api/axiosAdmin";

const RequestDetailsPage = () => {
  const { id } = useParams();

  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchRequestDetails = async () => {
      try {
        const response = await axiosAdmin.get(`/request/${id}`);
        setRequest(response.data);
      } catch (err) {
        setError("Failed to load request details");
      } finally {
        setLoading(false);
      }
    };

    fetchRequestDetails();
  }, [id]);

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this request?"))
      return;

    try {
      await axiosAdmin.delete(`/request/${id}/delete`);

      toast.success("Request was deleted");
      navigate("/admin-panel/requests");
    } catch (error) {
      console.error("Error while deleting", error);
      toast.error("Error while deleting");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Request Details</h1>
      <div className="bg-white shadow-md rounded-2xl divide-y divide-gray-200">
        {[
          { label: "ID", value: request.id },
          { label: "Track", value: `${request.artist} - ${request.trackName}` },
          { label: "DJ", value: request.djName },
          { label: "Location", value: request.placeName },
          { label: "Price", value: request.price },
          { label: "Username", value: request.username },
          { label: "User ID", value: request.userId },
          { label: "User message", value: request.message },
          { label: "DJ message", value: request.djMessage },
          { label: "Created At", value: formatDate(request.createdAt) },
          { label: "Updated At", value: formatDate(request.updatedAt) },
          { label: "Status", value: request.status },
        ].map((item, index) => (
          <div
            key={index}
            className={`py-3 px-2 ${
              index % 2 === 0 ? "bg-gray-50" : ""
            } text-sm sm:text-base`}
          >
            <strong className="block text-gray-600">{item.label}:</strong>
            <span className="text-gray-900 break-all">{item.value}</span>
          </div>
        ))}

        <div className="p-4">
          <button
            onClick={handleDelete}
            className="w-full sm:w-auto px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg shadow transition"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestDetailsPage;
